import { useSelector } from "react-redux";

import { RootState } from "reducers";

export function useDarkMode() {
	return useSelector((state: RootState) => state.ui.darkMode);
}
